const encodedURIQueryStringConverter = (url = '/', params = {}) => {
  let querystring = ''
  for (const key in params) {
    if (params[key]) {
      querystring += `${(querystring.length ? '&' : '') + key}=${encodeURI(
        params[key]
      )}`
    }
  }
  return url + (querystring ? `?${querystring}` : '')
}

export default encodedURIQueryStringConverter
